import { Color } from '@anov/3d-core'

const CircleShader = {
  uniforms: {
    iTime: { value: 0.0 },
    color: { value: new Color(1.0, 1.0, 1.0) }, // 添加颜色uniform，默认白色
    texturePlane: { value: null },
    // texturePlane2: { value: null },
  },
  vertexShader: `
  #include <common>
  #include <logdepthbuf_pars_vertex>
  varying vec3 vNormal; // 用于传递法线方向
  varying vec2 vUv;
  varying vec3 vWorldPosition;
void main() {
    #include <begin_vertex>
  #include <project_vertex>
  #include <logdepthbuf_vertex>
  // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
vUv = uv;
vNormal = normalize(mat3(modelMatrix) * normal);  // 使用模型矩阵旋转法线
vec4 modelPosition = modelMatrix * vec4(position, 1.0);
vWorldPosition = modelPosition.xyz;
gl_Position = projectionMatrix * viewMatrix * modelPosition;	 
}
`,
  fragmentShader: `
      varying vec2 vUv;
      uniform float iTime;
      uniform sampler2D texturePlane;   
      uniform vec3 color;
      #include <logdepthbuf_pars_fragment>
  
      vec4 normalBlend(vec4 base, vec4 blend) {
    // 正常混合模式(非预乘 alpha)
    vec3 resultColor = blend.rgb * blend.a + base.rgb * base.a * (1.0 - blend.a);
    float resultAlpha = blend.a + base.a * (1.0 - blend.a);    
    // 如果结果 alpha 不为零，则除以 alpha 来保持非预乘格式
    if (resultAlpha > 0.0) {
        resultColor /= resultAlpha;
    }   
    return vec4(resultColor, resultAlpha);
}

  vec2 rotate (vec2 uv,float angle){
		float sinA = sin(angle);
		float cosA = cos(angle);
		return uv.xy*mat2(cosA, -sinA, sinA, cosA);
	}
      void main() {
        #include <logdepthbuf_fragment>
                //*sin(mod(iTime,100.));  //*fract(mod(iTime,100.))
                float progress=fract(mod(iTime,100.))*0.1+0.4;
                         
                     float center1=step(distance(vUv,vec2(0.5,0.5)),0.10);
                     gl_FragColor=vec4(vec3(1.),center1*0.5);


   vec2 uvR=rotate(vUv-vec2(0.5,0.5),iTime)+0.5;
   vec4 tex2DNode = texture2D(texturePlane, uvR);
   vec4 tex2DNodeA=vec4(vec3(1.)*mix(color, vec3(1.0),0.5),tex2DNode.r);
    gl_FragColor=normalBlend(gl_FragColor,tex2DNodeA);   

                         float circleGradientMax=1.-smoothstep(0.20,0.22,distance(vUv,vec2(0.5,0.5))); 
              float circleGradient=pow(distance(vUv/.2/2.,vec2(0.5,0.5)/.2/2.),3.1)*3.; 
              vec4 circleGradien = vec4(vec3(1.),circleGradient*circleGradientMax)*vec4(color,1.9);
              gl_FragColor=normalBlend(gl_FragColor,circleGradien);

 float d = distance(vUv, vec2(0.5, 0.5));
float ring = exp(-150.0 * abs(d - 0.21)); // 指数衰减-10-150 控制光圈大小
vec4 ringColor = vec4(vec3(1.), ring) * vec4(color*1.8, 1.);
gl_FragColor=normalBlend(gl_FragColor,ringColor);
      }
  `,
}

export default CircleShader